/**
 * Reliable iOS native-shell detection for the React bundle.
 *
 * The iOS WebView sets a stable User-Agent token ('CountertopiOS/') on every
 * page — the most reliable signal, and the same one serve.js,
 * store-settings.html, paywall-modal.js, and subscription-gate.js use.
 *
 * window.isNativeShell (native-shell.js) is NOT loaded on most pages, and its
 * URL-param/sessionStorage detection is lost on in-WebView navigation, so it
 * cannot be relied on alone — doing so lets priced subscription prompts and
 * subscribe.html redirects leak through on iOS (App Store guideline 3.1.1).
 */
export function isIosShell() {
  if (typeof window === 'undefined') return false;
  try {
    if (/CountertopiOS\//.test(window.navigator?.userAgent || '')) return true;
  } catch (_) {}
  try {
    if (window.isNativeShell && window.isNativeShell()) return true;
  } catch (_) {}
  return false;
}
